
import api from '@/services/api';
import _ from 'underscore';
import DocumentCategory from '@/classes/DocumentCategory';
import {Module} from 'vuex';
import {RootState} from '@/types';

export interface DocumentCategoryState {
    categories: DocumentCategory[];
}

export const DocumentCategoryStore: Module<DocumentCategoryState, RootState> = {
    namespaced: true,

    state: {
        categories: []
    },

    getters: {

        category(state, category: string): DocumentCategory | undefined {
            return _.find(state.categories, (c: DocumentCategory) => {
                return category !== undefined && category !== null && category.toLowerCase() === c.category.toLowerCase();
            });
        },

        categories(state): DocumentCategory[] {
            return state.categories;
        }
    },

    mutations: {
        addCategory: (state: any, category: DocumentCategory) => {
            // We only want to add the category, if it hasn't already been added
            if (0 > _.findIndex(state.categories, (c: DocumentCategory) => {
                return category && category.category && category.category.toLowerCase() === c.category.toLowerCase();
            })) {
                state.categories.push(category);
            }
        },

        setCategories: (state, categories: DocumentCategory[]) => {
            state.categories = categories;
        },

        pruneCategory: (state: any, category: DocumentCategory) => {
            const idx = _.findIndex(state.categories, (c: DocumentCategory) => {
                return category && category.category && c.id === category.id && c.category === category.category;
            });

            if (idx >= 0) {
                state.categories.splice(idx, 1);
            }
        }
    },

    actions: {
        addCategory: ({commit}, category: DocumentCategory) => {
            commit('addCategory', category);
        },

        pruneCategory: ({commit}, category: DocumentCategory) => {
            commit('pruneCategory', category);
        },

        loadCategories: ({commit}) => {
            api().get('/documents/categories')
                .then((response) => {
                    const categories = _.chain(response.data as DocumentCategory[])
                        .map((c: DocumentCategory) => {
                            // TODO: Manipulate, if necessary
                            return c;
                        })
                        .sortBy('category')
                        .uniq(true, (c: DocumentCategory) => {
                            return c.category.toLowerCase();
                        })
                        .value();

                    commit('setCategories', categories);
                })
                .catch((err) => {
                    // TODO: Handle Error
                });
        }
    }
};
